// extracted by mini-css-extract-plugin
module.exports = {"container":"AngelCardList_container__1tV3s","sending":"AngelCardList_sending__3fudr"};